var myVar = setInterval(myTimer, 100);

function myTimer() {
  
  var parent = $(".selector-wrapper").parent();
  
  if(parent.hasClass("loaded")){
    myStopFunction()
    fauxSelect();
  }else{
  	parent.addClass("loaded") 
  } 
}

function myStopFunction() {
  clearInterval(myVar);
}


var chooseButton = `<button class="grid__item" ><h3 style="margin:0">Choose</h3> <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 286.0976562 164.2620239" style="enable-background:new 0 0 286.0976562 164.2620239;" xml:space="preserve"><style type="text/css">.st0{fill:none;stroke:#828282;stroke-width:30;stroke-miterlimit:10;}</style><polyline class="st0" points="275.4910583,10.6066017 143.0488281,143.0488281 10.6066017,10.6066017 "/></svg></button>`


function fauxSelect(){

    $(".selector-wrapper").each(function(){
      
      $(this).hide();
      
      var options = $(this).find("option");
      var label = $(this).find("label").text();
      var sizeguideButton = `<a href='' class="drawerButton" data-drawer="sizeguide" style="width:100%;text-align:right;margin:0;">Size Guide</a>`
      var array = [];
      
      
      $(options).each(function(i,option){
        
         var inventory = $("#ProductSelect-product-template option").eq(i).attr("data-inventory");
         var inventoryMessage = " — <strong>Only " + inventory + " left</strong>";
      
       	if( $(option).attr("disabled") == "disabled" ){
         
        	array = array + "<li class='grid__item disabled'>" + option.text + " — Sold Out</li>";
         
       	} else {
         
          if( inventory <= 3 && inventory > 0 ){
              
        		array = array + "<li class='grid__item' data-value='" + option.text + "'>" + option.text + inventoryMessage + "</li>";
              
            } else if( inventory > 0 ) {
            
              	array = array + "<li class='grid__item' data-value='" + option.text + "' >" + option.text + "</li>";
              
            } else {
            
//              array = array + "<li class='grid__item' data-value='" + option.text + "' >" + option.text + "— SOLD OUT</li>";
              	array = array + "<li class='grid__item' data-value='" + option.text + "' >" + option.text + "— PRE-ORDER</li>";
              
            }
       	}
      });
      
      
      if($(options).length > 1){
        let sizeButtonContainer = ``

        if(label == "Size"){
          sizeButtonContainer = `<div style='width:50%;text-align:right;font-weight:normal;'>${sizeguideButton}</div>`
        } 
        
        let buildSelect = `
        <div class='grid__item faux-select'>
          <label style='display:flex'>
            <div style='width:50%'>${label}</div>
            ${sizeButtonContainer}
          </label>
            ${chooseButton}
          <ul class='grid__item'>${array}</ul>
        </div>
        `
        
        $(this).after(buildSelect)
      
      }
      
    });
  
  listeners();

}



function listeners(){

	$(".faux-select button").on("click", function(e){
	
	  e.preventDefault();
	  $(this).siblings("ul").toggle();
	  
	});
	
	
	
	$(".faux-select li").on("click", function(e){
	
	  e.preventDefault();
      
	  let parent = $(this).parents(".faux-select");
      
      parent.find("ul").hide();
	  parent.find("button h3").text($(this).text());
	  
	  var index = $(this).index();
      var parentIndex = parent.index(".faux-select");
      
      $(".selector-wrapper").eq(parentIndex).find("select").val($(this).attr("data-value")).change();
	  
	});
  
   $(".drawerButton").on("click", function(e){
    e.preventDefault();
    let a = $(this).attr("data-drawer")
  	$(".productDrawerItem." + a).addClass("a")
    $(".productDrawers .curtain").fadeIn();
  })

}






